import { render, staticRenderFns } from "./SubmitBulkModeration.vue?vue&type=template&id=7da01bea"
import script from "./SubmitBulkModeration.vue?vue&type=script&lang=js"
export * from "./SubmitBulkModeration.vue?vue&type=script&lang=js"
import style0 from "./SubmitBulkModeration.vue?vue&type=style&index=0&id=7da01bea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports